<template>
   <div class="col-sm-12 text-right m-0" v-if="total">
        <button
          class="btn btn-lg btn-link p-2 mr-2"
          @click="firstPage"
          :disabled="pageNumber === 1"
        >
          <i class="fas fa-angle-double-left"></i>
        </button>
        <button
          class="btn btn-lg btn-link p-2 mr-2"
          @click="prevPage"
          :disabled="pageNumber === 1"
        >
          <i class="fas fa-angle-left"></i>
        </button>
        <span class="pgnt">Page {{ pageNumber }} of {{ pageCount }}</span>
        <button
          class="btn btn-lg btn-link p-2 ml-2"
          @click="nextPage"
          :disabled="pageNumber === pageCount"
        >
          <i class="fas fa-angle-right"></i>
        </button>
        <button
          class="btn btn-lg btn-link p-2 mr-2"
          @click="lastPage"
          :disabled="pageNumber === pageCount"
        >
          <i class="fas fa-angle-double-right"></i>
        </button>
      </div>
</template>

<script>
export default {
data(){
  return {
    pageNumber : 1,
    pageCount : 1
  }
},
props : ["total","pgNum"],
methods : {
  firstPage() {
      this.pageNumber = 1;
      this.$emit("sendPageNum",this.pageNumber);
    },
  nextPage() {
      this.pageNumber++;
      this.$emit("sendPageNum",this.pageNumber);
    },
    prevPage() {
      this.pageNumber--;
      this.$emit("sendPageNum",this.pageNumber);
    },
  lastPage() {
      this.pageNumber = this.pageCount;
      this.$emit("sendPageNum",this.pageNumber);
    },
    resetPageParams() {
      this.pageNumber = 1;
      this.pageCount = 1;
    },
    countOfPages(deviceCount) {
      let pageSize = 10;
      return Math.ceil(deviceCount / pageSize);
    },
},
watch : {
total : {
  immediate : true,
  handler(v){
    if(v)
  this.pageCount = this.countOfPages(v);
  else 
  this.pageCount = 1;
  }
},
pgNum : {
  immediate : true,
  handler(v){
    if(v)
    {
    this.pageNumber = v;
    }
  }
}
}
}
</script>

<style scoped>
.pgnt{
  font-size: 0.88rem;
}
</style>